var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 0.380859H24.3008C27.4754 0.380859 30.0498 2.9543 30.0498 6.12891V24.3008C30.0498 27.4754 27.4754 30.0498 24.3008 30.0498H6.12891C2.9543 30.0498 0.380859 27.4754 0.380859 24.3008V6.12891C0.380859 2.9543 2.9543 0.380859 6.12891 0.380859Z",
    stroke: "#D9DCE0",
    strokeWidth: 0.760742
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9038 12.1719H15.4683M10.9038 15.2148H14.4539M10.9038 18.2578H14.4539M16.4826 16.7363L18.0041 18.2578M18.0041 18.2578L19.5256 16.7363M18.0041 18.2578V12.1719",
    stroke: "#8E97A3",
    strokeWidth: 1.14111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/FilterButton.4e8973cdfe37db0ca9675f419ffdcce8.svg";
export { ForwardRef as ReactComponent };